<template>
	<div class="about-main-container">
		<div class="about-header">{{ $t('名称由来') }}</div>
		<div class="about-content">{{ $t('星云-愿我们的节点像漫天繁星一样数不胜数。帮助您自如的在信息的海洋中乘风破浪。无论是探索未知、体验快乐、收获价值还是汲取知识，我们都是您最忠实的小伙伴。') }}</div>
		<div class="about-header">{{ $t('产品简介') }}</div>
		<div class="about-content">{{ $t('星云加速器是Locklayer Technologies Inc. 公司（加拿大）旗下网络安全核心产品。我们致力于信息自由和隐私保护。在提供免费套餐的同时，提供稳定高速的VIP套餐可供选择。') }}</div>
		<div class="about-header">{{ $t('公司信息') }}</div>
		<div class="about-content">{{ $t('公司名称：') }}</div>
		<div class="about-content">Locklayer Technologies Inc.</div>
		<div class="about-content">{{ $t('公司地址：') }}</div>
		<div class="about-content">5880 Granville Ave, Richmond, BC, Canada, V7C 1E9</div>
		<div class="about-header" @click="onRedirect">{{ $t('软件官网（点击跳转）') }}</div>
	</div>
</template>
<script>
export default {
	name: "AboutPage",
	components: {},
	data() {
		return {}
	},
	methods: {
		onRedirect() {
			const officialWeb = 'https://www.locklayertech.com/'
			if (window.Android && typeof window.Android.onEvent === 'function') {
				// 触发自定义事件
				window.Android.onEvent('openBrowser', JSON.stringify({url: officialWeb}));
			} else if (window.chrome && window.chrome.webview) {
				window.chrome.webview.postMessage(JSON.stringify({
					type: 'openWebsite',
					url: officialWeb
				}));
			} else if (window.webkit && window.webkit.messageHandlers) {
				const message = {
					type: "openWebsite",
					url: officialWeb
				};
				window.webkit.messageHandlers.appInterface.postMessage(message);
			} else {
				window.open(officialWeb, '_blank');
			}
		}
	}
}
</script>

<style scoped>
.about-main-container {
	display: flex;
	flex-direction: column;
	align-items: start;
	color: #E6D5B8;
	padding: 0.4em;
	box-sizing: border-box;
}

.about-header{
	font-size: 1.4em;
	line-height: 1.4em;
	font-weight: bold;
	margin-top: 1em;
}

.about-content{
	text-align: start;
	font-size: 1.2em;
	line-height: 1.2em;
}
</style>